'use es6';

import { Record, List } from 'immutable';
const defaultAdSequenceNotificationsRecord = {
  notifyWhenStarted: false,
  notifyWhenEnded: false,
  notificationEmails: List()
};
const AdSequenceNotificationsRecord = Record(defaultAdSequenceNotificationsRecord);
export const loadFromDraft = draft => AdSequenceNotificationsRecord(Object.assign({}, draft, {
  notificationEmails: List(draft.notificationEmails)
}));
export const loadFromPublished = (sequenceNotifications, step, stageIds) => {
  if (step === 'attract') {
    return null;
  }

  if (!sequenceNotifications) {
    return AdSequenceNotificationsRecord(defaultAdSequenceNotificationsRecord);
  }

  const notifications = sequenceNotifications.reduce((record, notification) => {
    if (notification.triggeringEntityId === stageIds[`${step}CreatedAdId`]) {
      if (notification.notificationType === 'AD_SEQ_AD_ENABLED') {
        record.notifyWhenStarted = true;
      }

      if (notification.notificationType === 'AD_SEQ_AD_PAUSED') {
        record.notifyWhenEnded = true;
      }

      record.notificationEmails.add(notification.userId);
    }

    return record;
  }, {
    notifyWhenStarted: false,
    notifyWhenEnded: false,
    notificationEmails: new Set()
  });
  notifications.notificationEmails = List(notifications.notificationEmails);
  return AdSequenceNotificationsRecord(notifications);
};
export default AdSequenceNotificationsRecord;